<template>
  <div class="form-anchor">
    <anchor-item
      v-for="(item, index) in anchors"
      :key="index"
      :active="value == item.value"
      @click.native="click(item)"
      >{{ item.label }}</anchor-item
    >
  </div>
</template>
<script>
export default {
  name: 'form-anchor',
  props: {
    anchors: Array,
    value: String,
  },
  methods: {
    click(item) {
      this.$emit('input', item.value)
      this.$emit('select-anchor', item)
    },
  },
}
</script>
<style lang="less">
.form-anchor {
  box-sizing: border-box;
  border-left: 2px solid #cbcbcc;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>